import * as React from 'react'
import PropTypes from 'prop-types'

interface IconProps {
  color?: string
}

const StoreIcon: React.FC<IconProps> = ({ color }) => (
  <svg
    width="23"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M21.9 8.89l-1.05-4.37C20.63 3.62 19.85 3 18.94 3H5.05c-.9 0-1.69.63-1.9 1.52L2.1 8.89c-.24 1.02-.02 2.06.62 2.88.08.11.19.19.28.29V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-6.94c.09-.09.2-.18.28-.28.64-.82.87-1.87.62-2.89zM6 19v-4.07c.09.01.17.04.27.04.87 0 1.66-.36 2.24-.95.6.6 1.4.95 2.31.95.87 0 1.65-.36 2.23-.93.59.57 1.39.93 2.29.93.84 0 1.64-.35 2.24-.95.58.59 1.37.95 2.24.95.1 0 .18-.03.27-.04V19H6z"
      fill={color}
    />
  </svg>
)

StoreIcon.propTypes = {
  color: PropTypes.string,
}

StoreIcon.defaultProps = {
  color: '#2A42A7',
}

export default StoreIcon
